import { render, staticRenderFns } from "./DealsFilter.vue?vue&type=template&id=ad2a0a4a&scoped=true&"
import script from "./DealsFilter.vue?vue&type=script&lang=js&"
export * from "./DealsFilter.vue?vue&type=script&lang=js&"
import style0 from "./DealsFilter.vue?vue&type=style&index=0&id=ad2a0a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2a0a4a",
  null
  
)

export default component.exports